import { type ReactNode } from "react"

import { Icon } from "../Icon"
import { Text } from "../Text"
import styles from "./FormFieldError.module.css"

type FormFieldErrorProps = {
  children: ReactNode
  id?: string
}

export function FormFieldError(props: FormFieldErrorProps) {
  const { id, children } = props

  return (
    <Text
      id={id ? `${id}-form-field-error` : undefined}
      role="alert"
      color="tomato11"
      sx={{ marginTop: 4 }}
    >
      <Icon
        className={styles.icon}
        name="alert"
        size="small"
        color="tomato11"
      />{" "}
      {children}
    </Text>
  )
}
